/**
 * useResolve — owns GET /api/v1/metrics/resolve (build-spec §5: ONE call serves
 * the whole matrix window). TanStack Query + the carried AuthContext token.
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useAuth } from '../contexts/AuthContext'
import type { Cadence, ResolveResponse, Site } from '../types/metrics'
import { ApiError, fetchApi } from './apiFetch'

export function useResolve(
  periodFrom: string,
  periodTo: string,
  cadence: Cadence,
  site: Site | 'all'
): UseQueryResult<ResolveResponse, ApiError> {
  const { token } = useAuth()
  const params = new URLSearchParams({
    period_from: periodFrom,
    period_to: periodTo,
    cadence,
    site,
  })
  return useQuery<ResolveResponse, ApiError>({
    queryKey: ['resolve', cadence, periodFrom, periodTo, site],
    queryFn: () => fetchApi<ResolveResponse>(`metrics/resolve?${params.toString()}`, token),
    enabled: token !== null,
  })
}
